export const AddTradingAccountMessages = {
    CreateTradingClientFailed: {
        key: 'CreateTradingClientFailed',
        message: 'Error while processing the server request. Creation process failed at the first step.'
    },
    CreateTradingGroupFailed: {
        key: 'CreateTradingGroupFailed',
        message: 'Error while processing the server request. Creation process failed at the second step.'
    },
    CreateTradingAccountFailed: {
        key: 'CreateTradingAccountFailed',
        message: 'Error while processing the server request. Creation process failed at the third step.'
    },
    GetSelectedTradingGroupFailed: {
        key: 'GetSelectedTradingGroupFailed',
        message: 'Can\'t find details selected cash account.'
    }
};
